import rwlogo from './images/home/rwlogo.png';
import arrow from './images/home/arrow.png';
import headerbg from './images/home/headerbg.png';
import aboutshape from './images/home/aboutshape.png';
import bannerbg from './images/home/bannerbg.png';
import bannerbg2 from './images/home/bannerbg2.png';
import star from './images/home/star.png';
import quote from './images/home/left-quote.png';
import user from './images/home/user.png';
import blog1 from './images/home/blog1.jpg';
import rwsign from './images/home/rwsign.png';
import bannerarrow from './images/home/bannerarrow.png';
import bluelogo from './images/home/rwlogoblue.png';
import whatsapp from './images/home/whatsapp.png';
import aboutbg from './images/home/aboutbg.jpg';
import footerbg from './images/home/footerbg.png';
import popupbg from './images/home/popupbg.jpeg';
import banner1 from './images/home/banner1.png';
import mobilebanner from './images/home/mobilebanner.png';
import hydcharminar from './images/home/hyderabad-charminar.png';
import rwsignlogo from './images/home/rwsignlogo.png';
import popup1 from './images/home/pop1.png';
import popup2 from './images/home/pop2.png';
import notfound from './images/home/notfound.png';

import rwbrochure from './PDF/rwbrochure.pdf';


import platiummobileimg from './images/projects/Palatiumhero.png'
import courtone from './images/projects/t.east.png'
import courttwo from './images/projects/court-home-2.png'

//about
import aboutvideo from './images/about/aboutvideo.jpg';
import awardsimage from './images/about/awardsimage.png';
import aboutbg1 from './images/about/aboutbg.png';
import aboutbg2 from './images/about/about2.png';
import aboutbg3 from './images/about/aboutbg3.png';
import outline1 from './images/about/outline1.png';
import outline2 from './images/about/outline2.png';
import outline3 from './images/about/outline3.png';
import outline4 from './images/about/outline4.png';
import outline5 from './images/about/outline5.png';

//services
import servicesdetails1 from './images/services/services1.jpg';

import pattern from './images/services/pattern.png';

//portfolio
import portfolioslider1 from './images//portfolio/portfolio1.jpg';

//Blog
import blogslider1 from './images/blog/blogslider.png';
import bloguser from './images/blog/user.png';

import magaliobanner from './images/projects/megaliobanner.png';
import projectbannerbg from './images/projects/bannerbg.png';
import gradientline from './images/projects/gardientline.png';
import magaliologo from './images/projects/magaliologo.png';
import projectaboutbg from './images/projects/projectaboutbg.png';
import gal1 from './images/projects/g1.png';
import gal2 from './images/projects/gal2.png';
import gal3 from './images/projects/gal3.png';
import gal4 from './images/projects/gal4.png';
import gal5 from './images/projects/gal5.png';
import masterlayout from './images/projects/masterlayout.png';
import masterlayoutbg from './images/projects/masterlayoutbg.png';
import floorplanmasterplan from './images/projects/floorplansmasterplan.png';
import floor1 from './images/projects/floorplan.png';
import training from './images/projects/training.png';
import megaliomap from './images/projects/megaliomap.png';
import int1 from './images/projects/int1.png';
import int2 from './images/projects/int2.png';
import int3 from './images/projects/int3.png';
import int4 from './images/projects/int4.png';
import int5 from './images/projects/int5.png';

import bd1 from './images/about/bd1.png';
import bd2 from './images/about/bd2.png';
import bd3 from './images/about/bd3.png';
import bd4 from './images/about/bd4.png';
import bm1 from './images/about/bm1.png';
import bm2 from './images/about/bm2.png';
import bm3 from './images/about/bm3.png';
import bm4 from './images/about/bm4.png';

import about1 from './images/services/about1.png';
import about2 from './images/services//about2.png';
import about3 from './images/services//about3.png';

import nribg1 from './images/home/nribg1.jpg';
import nribg2 from './images/home/nribg2.jpg';

import handpointup from './images/services/pointing-up.png';
import addicon from './images/services/add.png';

import semicirclesvg from './images/semicircle.svg';
import flowchart1 from './images/flowchart-1.svg';


import rwbluelogo2 from './images/home/rwbluelogo2.png'
import ankura from './images/projects/anukura.png'
import palatium from './images/projects/palatium.png'
import vamsiram from './images/projects/vamsiram.png'
import  skymarq from "./images/projects/skymarq.png"
import latestmbbanner from "./images/home/latestmbbanner.png"
import latestdsbanner from './images/home/latestdsbanner.png'
import glasscurve from './images/home/glasscurve.png'
import mbglasscurve from './images/home/mbglasscurve.png'
import downarrow from './images/home/down-arrow.png'
import latestherosec from './images/home/latestherobanner.png' 
import hraimg from './images/home/hra and national.png'
import sale1 from './images/services/sale1.png'
import sale2 from './images/services/sale2.png'
import sale3 from './images/services/sale3.png'
import coachinghero from './images/home/coachinghero.png'
import coachexp from './images/home/coachexp.jpeg'
import storiescoach from './images/home/storiescoach.jpeg'
import successcoach from './images/home/successcoach.png'
import hydfooterimg from './images/home/hygfoterimg.png'
import webquote from './images/home/dialog.png'
import arrowele from './images/services/arrow.png'
import bobele from './images/services/bobelement.png'
import triangle from './images/services/trangleelement.png'



import scanner from './images/resume/scanner.png'
import tar from './images/resume/tarlogo.png'
import ira from './images/resume/irarealtyindia_logo.jpg.jpeg'
import landmark from './images/resume/images.png'
import salasar from './images/resume/images (5).jpg.jpeg'
import sreenidhi from './images/resume/sreenidhi11.png'
import magnifiq from './images/resume/images (6).jpg.jpeg'
import sastel from './images/resume/images (1).png'
import dell from './images/resume/images (2).png'
import suchindra from './images/resume/download (1) (1).png'
import avani from './images/resume/AvaniLogoNav.png'
import ornate from './images/resume/ornate_interiors_hyd_logo.jpg.jpeg'
import anmol from './images/resume/images (7).jpg.jpeg'
import pvr from './images/resume/pvrdevelopers_logo.jpg.jpeg'
import tejase from './images/resume/tejase.jpeg'
import ds from './images/resume/ds.png'
import hydhero from './images/resume/hyderabad-hero.png'
import hero2 from './images/resume/hero2.png'
import hydhero3 from './images/resume/hyd.jpg'
import hydhero4 from './images/resume/hyd2.jpg'
import hra from './images/resume/hra logo (1).png'
import nra from './images/resume/naa logo (1).png'



import bonus1 from './images/services/bonus1.webp'
import bonus2 from './images/services/bonus2.webp'
import bonus3 from './images/services/bonus3.webp'
import bonus4 from './images/services/bonus4.webp'
import bonus5 from './images/services/bonus5.webp'

import arun from './images/home/arun.jpg'
import brigdhar from './images/home/brigdhar.jpg'
import nandhini from './images/home/nandhini.jpg'
import mahesh from './images/home/maheshvalsa.jpg'
import amerjeet from './images/home/amret.jpg'

import lines1 from './images/services/pattern-background.png'
import megalieonew from "./images/projects/megalieonew.png"
import leadgenhero from "./images/Mentoring/leadgenhero.png"
import mleadgenheros from "./images/Mentoring/leadgenmobileherosec.png"
import HighTicketDealspdf from './PDF/HighTicketDeals.pdf'
import luxurysalesmasterypdf from './PDF/Luxury-Sales-Mastery.pdf'
import PersonalisedMentoringpdf from "./PDF/Personalised-Mentoring.pdf"
import  projectsmobileviewslider1 from './images/projects/mobileviewslider.png'
import xs from "./images/projects/xs.jpeg"
import careers from './images/about/careers.png'

export {
  scanner,tar,ira,landmark,salasar,sreenidhi,magnifiq,sastel,dell,suchindra,avani,tejase,
  ornate,anmol,pvr,ds,hydhero,hero2,bonus1,bonus2,bonus3,bonus4,bonus5,hydhero3,
  hydhero4,hra,nra,arun,brigdhar,nandhini,mahesh,amerjeet,lines1,megalieonew,
  leadgenhero,mleadgenheros,HighTicketDealspdf,luxurysalesmasterypdf,PersonalisedMentoringpdf,
  projectsmobileviewslider1,xs,careers
}


export {
  palatium,
  magaliobanner,
  projectbannerbg,
  gradientline,
  magaliologo,
  projectaboutbg,
  gal1,
  gal2,
  gal3,
  gal4,
  gal5,
  masterlayout,
  masterlayoutbg,
  floorplanmasterplan,
  floor1,
  training,
  megaliomap,
  int1,
  int2,
  int3,
  int4,
  int5,
  about1,
  about2,
  about3,
  platiummobileimg,courtone,courttwo,ankura,vamsiram,skymarq,latestmbbanner,latestdsbanner,glasscurve,
  mbglasscurve,downarrow,latestherosec,hraimg,sale1,sale2,sale3,coachinghero,
  coachexp,storiescoach,successcoach,hydfooterimg,webquote,arrowele,bobele,triangle
};

export {
  rwbrochure,
  aboutbg1,
  aboutbg2,
  aboutbg3,
  outline1,
  outline2,
  outline3,
  outline4,
  outline5,
  bd1,
  bd2,
  bd3,
  bd4,
  bm1,
  bm2,
  bm3,
  bm4,
  semicirclesvg,
  flowchart1,
};

export const Homeimages = {
  rwlogo,
  arrow,
  headerbg,
  aboutshape,
  bannerbg,
  star,
  quote,
  user,
  bannerbg2,
  blog1,
  rwsign,
  bannerarrow,
  bluelogo,
  whatsapp,
  aboutbg,
  footerbg,
  popupbg,
  banner1,
  mobilebanner,
  hydcharminar,
  rwsignlogo,
  popup1,
  popup2,
  notfound,
  nribg1,
  nribg2,
  rwbluelogo2
};

export const About = {
  aboutvideo,
  awardsimage,
};

export const Services = {
  servicesdetails1,
  pattern,
  handpointup,
  addicon,
};

export const Portfolio = {
  portfolioslider1,
};
export const Blog = {
  blogslider1,
  bloguser,
};
